import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import * as style from './style.css';

interface IMetroStationItemProps {
  name: string;
  travelTime: number;
  icon: React.ReactNode;
  color: string;
}

export const MetroStationItem: React.FC<IMetroStationItemProps> = ({ name, icon, travelTime, color }) => {
  return (
    <div className={style['item']}>
      <div className={style['metro-icon']}>
        {/* eslint-disable-next-line react/forbid-elements */}
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 100 100">
          {/* tslint:disable-next-line:max-line-length */}
          <path
            fill={`#${color}`}
            d="M50 81.7l14.6-25.4 6.1 17.2h-4.9v7.6H95v-7.6h-5.6l-21-55.2-18.4 34-18.4-34-21 55.2H5v7.6h29.2v-7.6h-4.9l6.1-17.2L50 81.7"
          />
        </svg>
      </div>

      <UIText2>{name}</UIText2>

      <div className={style['travel-icon']}>{icon}</div>

      <UIText2 color="text-secondary-default">{travelTime} мин.</UIText2>
    </div>
  );
};
